module.exports = __webpack_public_path__ + "482d940bf55746f6ebe39187073d31e2.svg";